/**
 * Date-extensions locale Lithuanian [lt]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('lt', {
    monthNames: ['Sausis','Vasaris','Kovas','Balandis','Gegužė','Birželis','Liepa','Rugpjūtis','Rugsėjis','Spalis','Lapkritis','Gruodis'],
    monthShortNames: ['Sau','Vas','Kov','Bal','Geg','Bir','Lie','Rgp','Rgs','Spa','Lap','Grd'],
    dayNames: ['Sekmadienis','Pirmadienis','Antradienis','Trečiadienis','Ketvirtadienis','Penktadienis','šeštadienis'],
    dayShortNames: ['Sek','Pir','Ant','Tre','Ket','Pen','Šeš']
});
